import { NavItem } from "../atoms/navItem";
import { useEffect, useState, useContext, useRef } from "react";
import { ThemeContext, UserContext } from "../App";
import { ip } from "../api/api";
import defaultLogo from "../assets/expligo_logo.png"
import publicDefaultLogo from "../assets/expligo_abstract_5.png"
import { handleDocumentValues } from "../functions/handleTheme";

export function SideBar({ navigationComps, active, onClick, isSidebarOpen, setIsSidebarOpen, handleLogoClick, brandingLogo, alignment, hide }) {
  const userContext = useContext(UserContext);
  const themeContext = useContext(ThemeContext);
  const [brandingLogoState, setBrandingLogo] = useState("");
  const [alignmentState, setAlignmentState] = useState('left');
  const sidebarRef = useRef(null);
  const isPublic = userContext.account_type === 1;
  const settingObj = {
    navID: 8,
    icon: "setting",
    navTitle: "Instellingen",
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.SET_ALIGNMENT) {
        setAlignmentState(event.data.SET_ALIGNMENT);
      }
      if (event.data?.SET_LOGO) {
        const file = event.data.SET_LOGO;
        if (file instanceof File) {
          const logoUrl = URL.createObjectURL(file);
          setBrandingLogo(logoUrl);
        } else {
          setBrandingLogo(`${ip}/${event.data.SET_LOGO}`);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);



  useEffect(() => {
    function handleClickOrScrollOutside(event) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    }

    function handleScroll() {
      setIsSidebarOpen(false);
    }

    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOrScrollOutside);
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOrScrollOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isSidebarOpen]);


  useEffect(() => {
    if (sidebarRef.current && themeContext?.sidebar_style !== undefined) {
      handleDocumentValues(window.document, 'sidebar_style', themeContext.sidebar_style);
    }
  }, [themeContext?.sidebar_style]);

  const headerSidebarStyle = {
    display: "flex",
    justifyContent: alignment === 'left' ? 'flex-start' : alignment === 'center' ? 'center' : 'flex-end',
  };
  if (hide) {
    return <></>;
  }
  return (
    <div
      ref={sidebarRef}
      className={`vertical complete-width sidebar card-background-color ${isSidebarOpen ? "open" : "closed"} ${isPublic ? "public-sidebar" : ""} ${isMobile ? "mobile-sidebar" : ""}`}>
      <div className="header-sidebar" style={headerSidebarStyle}>
        <a href="/" onClick={handleLogoClick}> <img style={{ height: "3.1rem", objectFit: "contain" }} src={brandingLogoState ? brandingLogoState : brandingLogo ? `${ip}/api/media/${brandingLogo}` : isPublic ? publicDefaultLogo : defaultLogo} alt="logo" /></a>
      </div>
      <div className="top-sidebar grid-layout">
        {navigationComps.map((comp, index) => {
          if (!userContext.permissions.includes(comp.permission) && comp.permission) {
            return<></>;
          }
          return (
            <NavItem
              key={comp.navID}
              onClick={() => onClick(comp)}
              active={active === comp.navID}
              navtitle={comp.navTitle}
              icon2={comp.icon}
              navdata={`navItem${comp.navID}`}
            />
          );
        })}
        {isMobile && (
          <NavItem
            key={settingObj.navID}
            onClick={() => onClick(settingObj)}
            active={active === settingObj.navID}
            navtitle={settingObj.navTitle}
            icon2={settingObj.icon}
            navdata={`navItem${settingObj.navID}`}
          />
        )}
      </div>
      <div className="bottom-sidebar">
        <NavItem
          onClick={() => onClick(settingObj)}
          active={active === settingObj.navID}
          navtitle={settingObj.navTitle}
          icon2={settingObj.icon}
          navdata={`navItem${settingObj.navID}`}
        />
      </div>
    </div>
  );
}
